const apiAddressConst = "https://widget.datablocks.se/api/rose";
const apiCustomerIdConst = "c77dd5d1-dfa4-4e34-8cd5-c2c3c1599f07";
const apiTokenConst = "bffce53a-6b62-43cc-8557-f5edaa3024e8&customerId=c77dd5d1-dfa4-4e34-8cd5-c2c3c1599f07&useCustomerSettings=true";

function setupObserver() {
  let observer = new MutationObserver(mutationRecords => {
    modifyFetchedChart();
    observer.disconnect();
  });

  $( document ).ready(function() { 
    observer.observe($("#owner-list")[0], {
      childList: true,
      subtree: true,
      characterDataOldValue: true,
    });  
  });
}

function modifyFetchedChart() {
  $('.mf-tbl-col-0').each(function(){
    let previousSibling =  $(this).prev().first();
    if (!$(previousSibling).hasClass('mf-tbl-col-a'))
        $(previousSibling).addClass('mf-tbl-col-a');
  });
  /*$('.mf-tbl-col-1').each(function(){
    let nextSibling =  $(this).next().first();
    if (!$(nextSibling).hasClass('mf-tbl-col-2'))
        $(nextSibling).addClass('mf-tbl-col-2');
  });*/
  $('p.source-text').remove();
  $('.mf-tbl-col-a').remove();
  //$('.mf-tbl-col-2').hide();
  $('.mf-tbl-col-4').hide();
  $('.mf-tbl-col-5').hide();
  (Shopify.locale == 'sv') ? $('.mf-tot-owners .mf-tbl-col-0')[0].innerHTML = 'Antal aktieägare' : $('.mf-tot-owners .mf-tbl-col-0')[0].innerHTML = 'Number of Shareholders'; 
}

function setupChart() {
  var locale = Shopify.locale;
  (function(widgets) {
    var url = apiAddressConst;
    if (!window._MF) {
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = url + "/assets/js/loader-v4.js";
        document.getElementsByTagName("body")[0].appendChild(b);
    }
    window._MF = window._MF || {
        data: [],
        url: url,
        ready: !!0,
        render: function() { window._MF.ready = !0 },
        push: function(w) { window._MF.data.push(w) }
    };	
    window._MF.push(widgets);
  })([{
    query:"#owner-list"
  ,callback:  false
  ,className: "owner-list list-comp one show"
  ,customerId: apiCustomerIdConst
  ,demo: false
  ,locale: locale
  ,token: apiTokenConst
  ,widget: "owner-list"
  } 
  ],
  );
}

setupObserver();
setupChart();